(ns ui.components.selection-toolbar.zapkit-styles)

;; ----------------------------------------------------------------------------
;; AUTO-GENERATED FILE — DO NOT EDIT MANUALLY.
;; Regenerate via: scripts/convert_zapkit_json.bb <source>.json <output-dir-or-file>
;; (run from the project root directory).
;; Source: zapkit-components/src/components/SelectionToolbar/styles.json
;; Source commit: 8f1c2f5df9b8865927daf98fa0adbf80c955e4da
;; ----------------------------------------------------------------------------

(def selection-toolbar
  {:root
   {:base
    "tw2-inline-flex tw2-max-w-full tw2-items-center tw2-gap-selection-toolbar-gap tw2-bg-bg-selection-toolbar tw2-px-selection-toolbar-padding-x tw2-py-selection-toolbar-padding-y tw2-rounded-selection-toolbar tw2-shadow-md",
    :compound-variants [],
    :default-variants {}},
   :count
   {:base
    "tw2-text-body-md tw2-shrink-0 tw2-whitespace-nowrap tw2-text-selection-toolbar",
    :compound-variants [],
    :default-variants {}},
   :_meta
   {:tokens
    ["bg-selection-toolbar"
     "body-md-font-size"
     "body-md-font-weight"
     "body-md-line-height"
     "radius-selection-toolbar"
     "spacing-selection-toolbar-gap"
     "spacing-selection-toolbar-padding-x"
     "spacing-selection-toolbar-padding-y"
     "text-selection-toolbar"],
    :generated-from
    "src/components/SelectionToolbar/SelectionToolbar.styles.ts"}})
